var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFakeMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4983 9.21312L12.3865 9.68961L13.2418 10.5449L22.7614 20.0649L20.0647 22.7616L10.5448 13.2416L9.68941 12.3863L9.21292 13.4981L6.23079 20.4568L0.989666 0.989753L20.4568 6.23091L13.4983 9.21312Z",
    fill: "#4D8DF4",
    stroke: "#193676",
    strokeWidth: 1.63792
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFakeMouse);
export default __webpack_public_path__ + "static/media/fake-mouse.c3cb87cd60f469bce5d9b0c424f5eeb5.svg";
export { ForwardRef as ReactComponent };